export default __webpack_public_path__ + "static/media/csv-download.fe1956ce.svg";